// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"MD-z","smallCardRow":"ND-z","largeCardRow":"OD-z","productSearchRow":"PD-z","curatedRow":"QD-z"};